import ModulWithRedux from './ModulWithRedux';
import l10n from '../util/l10n';
import TableModuleData from './table/ModuleData';
import WebView from './table/WebView';
import diyLightTheme = require('../material-ui/diyLightTheme');
import { TableEditViewBasics, TableEditViewFormatText, TableEditViewAdvanced } from './table/EditView';
import ModuleInlineEditor from './common/js/ModuleInlineEditor';
import { setUndoState, setRedoState } from '../module-action-bar/index';
import AppRegistry from "diy/AppRegistry";
import TabOptions from '../actionBar/interfaces/TabOptions';

function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

declare var CKEDITOR: any;

interface CommandListener {
    (this: {state: number}): void;
}

export default class ModulTabelle extends ModulWithRedux<TableModuleData> {

    hasUndoRedo = true;
    helpArticleId = "table";
    CONFIG_MIN_WIDTH = 545;

    protected data: TableModuleData;
    private ckEditorPromise: Promise<CKEditor>;
    private ckEditorPromiseResolve: (ckEditor: CKEditor) => void;
    private inlineEditor: ModuleInlineEditor = null;

    constructor(moduleId: number) {
        super(moduleId);
        this.ckEditorPromise = new Promise<CKEditor>((resolve, reject) => {
            this.ckEditorPromiseResolve = resolve;
        });
    }

    getInPlaceEditViewClass(): any {
        return null;
    }

    getWebViewClass() {
        return WebView;
    }

    getCKEditorPromise() {
        return this.ckEditorPromise;
    }

    loadData(data: TableModuleData) {
        this.data = data;
        this.data.text = this.getContentElement().querySelector('.tableContainer').innerHTML;
    }
    /**
     * @override
     * strictly for typing purposes
     */
    getData() {
        return this.data;
    }

    initCKEditor(textElement: HTMLElement) {
        this.inlineEditor = new ModuleInlineEditor(this, textElement);

        this.inlineEditor.startEditing({
            // this setting is primary used for setting the z-index
            // of CKEditor dialogs, and these should be the same as
            // standard Material UI dialogs zIndex
            baseFloatZIndex: diyLightTheme.zIndex.dialog,
            toolbar: 'Table',
            toolbar_Table: this.getCkeditorToolbarConfig(),
            diyhelpLabel: 'table',
            extraPlugins: 'tableresize',
            toolbarStartupExpanded: true,
            toolbarCanCollapse: false,
            allowedContent: !this.getData().supports.textSanitizeHtml,
            pasteFromWordRemoveFontStyles: false,
            pasteFromWordRemoveStyles: false,
            hideToolbar: true
        });

        this.inlineEditor.editor.on('pluginsLoaded', (ev: any) => {
            ev.editor.focus();
        });

        this.inlineEditor.editor.on('instanceReady', () => {
            this.ckEditorPromiseResolve(this.inlineEditor.getEditor());

            const store = getStore();

            this.inlineEditor.editor.getCommand('undo').on('state', function() {
                store.dispatch(setUndoState({enabled: this.state !== CKEDITOR.TRISTATE_DISABLED}));
            } as CommandListener);

            this.inlineEditor.editor.getCommand('redo').on('state', function() {
                store.dispatch(setRedoState({enabled: this.state !== CKEDITOR.TRISTATE_DISABLED}));
            } as CommandListener);

        });
    }

    getActionBarTabs(): TabOptions[] {
        return [
            {
                label: l10n('module.table.tabs.basic'),
                content: this.getConnectedComponent(TableEditViewBasics)
            },
            {
                label: l10n('module.table.tabs.textFormat'),
                content: this.getConnectedComponent(TableEditViewFormatText)
            },
            {
                label: l10n('module.table.tabs.advanced'),
                content: this.getConnectedComponent(TableEditViewAdvanced)
            }
        ];
    }

    undoHandler = () => {
        this.inlineEditor.getEditor().execCommand('undo');
    }

    redoHandler = () => {
        this.inlineEditor.getEditor().execCommand('redo');
    }

    getSaveData () {
        let data: any;
        let i: number;
        let isSaveDataReplaced = false;
        data = super.getSaveData();

        // if a `text` property is present then overrite it //
        for (i = 0; i < data.length; i++) {
            if (data[i].name === 'text') {
                data[i].value = this.inlineEditor.getHtmlData();
                isSaveDataReplaced = true;
            }
        }

        // if it isn't found, we add it //
        if (!isSaveDataReplaced) {
            data.text = this.inlineEditor.getHtmlData();
        }

        return data;
    }
    /**
     * @override
     */
    close(userClose?: boolean, cancelEdit?: boolean, isSaving?: boolean, isUserAction?: boolean) {
        this.inlineEditor.stopEditing();
        super.close(userClose, cancelEdit, isSaving, isUserAction);
    }

    private getCkeditorToolbarConfig() {
        return [
            ['FontSize'],
            ['Undo', 'Redo'],
            ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['DiyLink', 'DiyUnlink'],
            ['DiyTextColor'],
            ['PasteText', 'RemoveFormat'],
            ['Sourcedialog', 'PasteFromWord', 'SelectAll'],
            ['HelpButton'],
            ['CloseButton'],
            ['Image'],
            '/',
            ['Table'], ['TableMixed'],
            ['TableInsertRowBefore', 'TableInsertRowAfter', 'TableDeleteRow'],
            ['TableInsertColumnBefore', 'TableInsertColumnAfter', 'TableDeleteColumn'],
            ['TableSplitVertically', 'TableSplitHorizontally'],
            ['TableMergeRight', 'TableMergeDown', 'TableMerge']
        ];
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulTabelle.ts
 **/